(function(){
    'use strict';

    var originSelect = {
        templateUrl: 'app/components/originSelect/originSelect.html',
        controller: originSelectController,
        controllerAs: 'vm',
        bindings: {
            onOriginSelected: '&'
        }
    };

    angular
        .module('completeAir')
        .component('originSelect', originSelect)

    originSelectController.$inject = ['$state', '$stateParams', 'linkService', 'locationService', '$translate'];

    function originSelectController($state, $stateParams, linkService, locationService, $translate) {
        var vm = this;

        vm.$onInit = function () {
            vm.state = $state;
            vm.stateParams = $stateParams;

            locationService.getLocations().then(function(locations) {
                locations.push({
                    id: 0,
                    name: $translate.instant('global.all')
                });
                vm.selectOriginOption = locations;

                if ($stateParams.originId == null) {
                    vm.origin = vm.selectOriginOption[0];
                    vm.onOriginSelected({
                        id: vm.origin.id,
                        option: vm.origin.name
                    });
                }
                else {
                    var id = parseInt(vm.stateParams.originId);
                    var name = vm.selectOriginOption.filter(function(o) { return o.id == id; })[0].name
                    vm.origin = { id: id, name: name };
                    vm.onOriginSelected({
                        id: id,
                        option: name
                    });
                }
                
            });
        }

        vm.setOriginSelected = function (id) {
            linkService.reloadRoute($state.current, {
                originId: id,
                page: 0,
                size: 10
            });
        };
    }
})();

